import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import { Box, IconButton, InputBase } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import Styles from '../style/theme'

function SearchBox(props) {
  const { placeholder, value, onChange, clearKeyword, width, height } = props
  return (
    <Box
      component="form"
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width,
        height,
        borderRadius: '8px',
        border: 1,
        borderColor: Styles.Color.SecondaryGray2,
        boxSizing: 'border-box',
      }}>
      <InputBase
        sx={{
          ml: 1,
          mt: 0.5,
          flex: 1,
          fontSize: '16px',
          color: Styles.Color.SecondaryGray4,
          input: {
            '&::placeholder': {
              opacity: 1,
            },
          },
        }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
          }
        }}
      />
      {value ? (
        <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={clearKeyword}>
          <ClearIcon />
        </IconButton>
      ) : (
        <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
          <SearchIcon />
        </IconButton>
      )}
    </Box>
  )
}

SearchBox.defaultProps = {
  placeholder: '',
  value: '',
  onChange: () => {},
  clearKeyword: () => {},
  width: '285px',
  height: '40px',
}
SearchBox.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  clearKeyword: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default SearchBox
